// extracted by css-extract-rspack-plugin
export default {"streamingContent":"StreamingContent-module__streamingContent--Bzbw8"};